export const firebaseConfig = {
  apiKey: "AIzaSyCtOhnVPZG0GK6Vhxrdqq46_pqccrYu1Bc",
  authDomain: "msa-psg-registration-2266b.firebaseapp.com",
  projectId: "msa-psg-registration-2266b",
  storageBucket: "msa-psg-registration-2266b.appspot.com",
  messagingSenderId: "1086096903202",
  appId: "1:1086096903202:web:13775e495b4b02939d4e7b",
  measurementId: "G-TD04TPRY7L",
};
